import React from "react";
import Modal from "react-modal";

export default function ModalText(args) {

    return (
        <div>
            <Modal
                style={{ overlay: { zIndex: 9999 }, content: { width: '30%' } }}
                isOpen={true}
                onRequestClose={args.handleCloseModal}
                contentLabel="Калькуляция"
                appElement={document.getElementById('root') || undefined}
                shouldCloseOnOverlayClick={true}
            >
                <div className="textModal">
                    <h1>Калькуляция</h1>
                    <table>
                        <tbody>
                            <tr>
                                <th>Цена</th>
                                <th>Описание</th>
                            </tr>
                            <tr>
                                <td>
                                    {args.dataresponse.base}
                                </td>
                                <td>
                                    Базовая цена
                                </td>
                            </tr>
                            {args.dataresponse.components && args.dataresponse.components.map((c, index) => (
                                <tr>
                                    <td>
                                        {c.value}
                                    </td>
                                    <td>
                                        {c.options}
                                    </td>
                                </tr>
                            ))}

                            {/*<tr>*/}
                            {/*    <td class="buttons-table">*/}
                            {/*        <button class="glow-button" onClick={args.handleCloseModalм} title="Нажмите, чтобы закрыть" >Закрыть</button>*/}
                            {/*    </td>*/}
                            {/*</tr>*/}
                        </tbody>
                    </table>
                </div>
            </Modal>
        </div>
    );
}